/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Teamid1Inputs */

const en_entity_teamid1 = /** @type {(inputs: Entity_Teamid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team ID`)
};

const de_entity_teamid1 = /** @type {(inputs: Entity_Teamid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

/**
* | output |
* | --- |
* | "Team ID" |
*
* @param {Entity_Teamid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_teamid1 = /** @type {((inputs?: Entity_Teamid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Teamid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_teamid1(inputs)
	return de_entity_teamid1(inputs)
});
export { entity_teamid1 as "entity_teamId" }